type Props = {
	children: React.ReactNode;
};

const PackageBlockContent = ({ children }: Props) => {
	return <div className="tablet:p-6 p-4">{children}</div>;
};

export default PackageBlockContent;
